<template>
  <div class="container">
    <div class="row">
      <div class="col-lg-4">
        <show-basic-information v-bind:api_data="api_data"></show-basic-information>
      </div>
      <div class="col-lg-4">
        <show-family-information v-bind:api_data="api_data"></show-family-information>
      </div>
      <div class="col-lg-4">
        <show-gov-scheme-information v-bind:api_data="api_data"></show-gov-scheme-information>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <show-land-information v-bind:api_data="api_data"></show-land-information>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <show-livelihood-information v-bind:api_data="api_data"></show-livelihood-information>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <show-cultivation-information v-bind:api_data="api_data"></show-cultivation-information>
      </div>
    </div>
    <vue-fab mainBtnColor="#3599DB">
      <fab-item @clickItem="$router.push({name: 'farmer'})" :idx="0" title="Back" icon="list"/>
    </vue-fab>
  </div>
</template>

<script>
import {FARMER_SINGLE} from "@/core/services/store/farmer.module";
import showBasicInformation from './partials/showBasicInformation'
import showFamilyInformation from './partials/showFamilyInformation'
import showGovSchemeInformation from './partials/showGovSchemeInformation'
import showLandInformation from './partials/showLandInformation'
import showCultivationInformation from './partials/showCultivationInformation'
import showLivelihoodInformation from './partials/showLivelihoodInformation'
import {ADD_BODY_CLASSNAME, REMOVE_BODY_CLASSNAME} from "@/core/services/store/htmlclass.module";

export default {
  name: "farmer-edit",
  components: {
    showBasicInformation,
    showFamilyInformation,
    showGovSchemeInformation,
    showLandInformation,
    showCultivationInformation,
    showLivelihoodInformation
  },
  beforeMount() {
    this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
    this.$toast.open(this.$t('Data Loading'));
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.getSingle(vm)
    });
  },
  methods: {
    getSingle(vm) {
      vm.$store.dispatch(FARMER_SINGLE, {id: vm.$route.params.id}).then(value => vm.api_data = {Farmer: value})
        .then(() => this.$nextTick(() => this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading")));
      localStorage.setItem('last_show_opened_record', vm.$route.params.id)
    }
  },
  data() {
    return {
      api_data: {}
    };
  },
};
</script>
